module.exports = __webpack_public_path__ + "static/img/download-app-qrcode.ed57b20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download-app-qrcode.jpg
// module id = HMd3
// module chunks = 1